/**
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} client
 * apiPaymentUrl
 * */

export default (client, { apiPaymentUrl }) => {
  const root = `${apiPaymentUrl}/commission`

  return {
    withdrawalCommission(amount) {
      const url = root
      const params = { amount }
      return client.get(url, { params })
    },
  }
}